// T0 — Métadonnées de navigation des pages (titres lisibles + descriptions + icônes).
// Clé = nom de fichier de la page (sans .js) découvert par require.context dans App.js.
// Permet d'afficher des libellés conviviaux dans la sidebar et l'accueil au lieu des noms de fichiers.
// Les noms d'icônes correspondent aux exports de `lucide-react`.

export const PAGE_META = {
  ProcessDocumentation: {
    title: 'Process',
    description: 'Modélisation visuelle interactive d\'un processus (couloirs, décisions, transitions)',
    icon: 'GitBranch',
    order: 1,
  },
  FunctionalSpecification: {
    title: 'Documentation Fonctionnelle',
    description: 'POC interactif de l\'écran Agents + guide utilisateur (créer / modifier / tester)',
    icon: 'LayoutDashboard',
    order: 2,
  },
  InfrastructureDocumentation: {
    title: 'Architecture & Infrastructure',
    description: 'Composants, zones, agents et connexions réseau',
    icon: 'Network',
    order: 3,
  },
  API_Documentation: {
    title: 'API',
    description: 'Référence des endpoints REST (collections Postman)',
    icon: 'Webhook',
    order: 4,
  },
  'sdk-guide-page': {
    title: 'Guide SDK',
    description: "Protocole agent, modèle d'interaction et exemples",
    icon: 'Code2',
    order: 5,
  },
  InstallationGuide: {
    title: 'Installation',
    description: 'Déploiement du backend, du frontend et des agents',
    icon: 'Download',
    order: 6,
  },
  ConfigurationGuide: {
    title: 'Configuration',
    description: 'Paramètres système, sécurité et produit',
    icon: 'Settings2',
    order: 7,
  },
};

// Métadonnées d'une page (fallback : titre = nom de fichier).
export const pageMeta = (name) => PAGE_META[name] || { title: name, description: '', icon: 'FileText', order: 99 };
